import { Component, Input, OnInit } from '@angular/core';
import { CataloguesService } from '../../../../core/services/catalogues.service';
import { CatalogueType } from '../../../../data/models';
import { RepoSettingsService } from '../../../../data/repositories/repo-settings.service';
import { LayoutService } from '../../layout.service';

@Component({
    selector: 'app-sidebar2-subpanel-catalogues',
    templateUrl: './sidebar2-subpanel-catalogues.component.html',
    standalone: false,
})
export class Sidebar2SubpanelCataloguesComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() dropDownClasses: string;
    dropdownOpen = true;
    numOfCatalogues = 0;
    numOfRecipes = 0;

    selections = {
        allChecked: true,
        itemCataloguesChecked: true,
        recipeCataloguesChecked: true,
    };

    constructor(
        private settings: RepoSettingsService,
        private cataloguesService: CataloguesService,
        public layoutService: LayoutService
    ) {}

    ngOnInit(): void {
        if (this.settings.NavigationV2CataloguesSelections) {
            this.selections = JSON.parse(this.settings.NavigationV2CataloguesSelections);
        }
        this.cataloguesService.notifyCatalogueSelectionFilter();

        this.cataloguesService.getCatalogueTypeCounts().then((r) => {
            // @ts-ignore TS2532
            this.numOfCatalogues = r.data.catalogueTypeCounts.find((c) => c.catalogueType === CatalogueType.Catalogue).count;
            // @ts-ignore TS2532
            this.numOfRecipes = r.data.catalogueTypeCounts.find((c) => c.catalogueType === CatalogueType.Recipe).count;
        });
    }

    headerLink() {
        this.dropdownOpen = !this.dropdownOpen;
    }

    toggleSelection(s: string) {
        if (s !== 'allChecked') {
            this.selections.allChecked = false;
            // @ts-ignore TS7053
            this.selections[s] = !this.selections[s];
        } else {
            this.selections.itemCataloguesChecked = !this.selections[s];
            this.selections.recipeCataloguesChecked = !this.selections[s];
            this.selections.allChecked = !this.selections[s];
        }

        this.settings.NavigationV2CataloguesSelections = JSON.stringify(this.selections);
        this.cataloguesService.notifyCatalogueSelectionFilter();
    }
}
